
import "../search/index.less"
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Tabs, Popup, Loading, Icon, List } from 'react-vant';
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { getSaleCards, getCards } from "../../api/url.js"
import { changeRefiningActive, clearRefiningCardList, changeSelectCardList, changeIsSaveCard } from '../../store/module/search';
import loading from '@/assets/images/cards/loading.png'
import usePlaySound from "@/hook/usePlaySound.tsx"
import activeImg from "../../assets/images/selectActive.png"

import Sale from "../cards/Sale";
import CardItem from "../../components/CardItem.js";
import TalkMessage from "../../components/message/TalkMessageToast.js";
import RefinComponent from "./refining"
import RefiningConsumption from "../../components/rafining/refiningConsumption.js";
import Back from "../../components/common/BackComp"
import ButtonComp from "../../components/common/ButtonComp.js";
import Mine from "../changeBackground/Mine.js";
import { getShopPayCountHandle } from "@/api/starpay.js"
import { changeShopCount } from "../../store/module/lottery.js";
// import WebApp from "@twa-dev/sdk";
import { postWarningInformation } from "@/api/url.js"
import { useTranslation } from "react-i18next";

const pageSize = 10
var initPriceList: any = [];

const Refining = () => {
    const { t } = useTranslation();
    const cardLevelList = [
        {
            "id": "1",
            "name": t("card_level.nature")
        },
        {
            "id": "2",
            "name": t("card_level.bronze")
        },
        {
            "id": "3",
            "name": t("card_level.silver")
        },
        {
            "id": "4",
            "name": t("card_level.gold")
        },

        {
            "id": "5",
            "name": t("card_level.diamond")
        }

    ]
    const tabsList = [

        {
            "id": "4",
            "name": t("card_level.gold")
        },
        {
            "id": "3",
            "name": t("card_level.silver")
        },
        {
            "id": "2",
            "name": t("card_level.bronze")
        },
        {
            "id": "1",
            "name": t("card_level.nature")
        }
    ]
    const navigate = useNavigate()
    const refiningActive = useSelector((state: any) => state.search.refiningActive)
    const refiningCardList = useSelector((state: any) => state.search.refiningCardList)
    const isSelect = useSelector((state: any) => state.search.isSelect)
    const selectCardList = useSelector((state: any) => state.search.selectCardList)
    const isSaveCard = useSelector((state: any) => state.search.isSaveCard)

    const dispatch = useDispatch()
    const backPlaySound = usePlaySound('back')
    const closePlaySound = usePlaySound('close')


    const [isLoading, setIsLoading] = useState(false)
    const popupRef = useRef(null)
    const isInitLoading = useRef(true)
    const currPage = useRef(1)
    const total = useRef(0);
    const [saleCardsData, setSaleCardsData] = useState<any>([])
    const [finished, setFinished] = useState(false);
    const listRef = useRef(null)
    const [popupIsShow, setPopupIsShow] = useState(true)
    const indexList = useRef<any>([])
    const [refiningIsShow, setRefiningIsShow] = useState(false)
    const [isShowRefiningConsumption, setIsShowRefiningConsumption] = useState(false)
    const { shopCount } = useSelector((state: any) => state.lottery)



    //change tabs
    const changeTabHandle = async (name: any) => {
        closePlaySound()
        dispatch(changeRefiningActive(name))
        setFinished(false)
    }

    //clickTabHandle
    const clickTabHandle = () => {
        closePlaySound()
        isInitLoading.current = true;
        return false
    }

    const [refiningCount, setRefiningCount] = useState(0)

    useEffect(() => {
        dispatch(clearRefiningCardList())
        const list = [Number(refiningActive), Number(refiningActive), Number(refiningActive) + 1]
        indexList.current = addCardLevel(list)
        isInitLoading.current = true;
        setIsLoading(false)
        initPriceList = []
        currPage.current = 1
        setSaleCardsData([])
        getDataList()
        shopPayCountHandle()

    }, [refiningActive])

    const addCardLevel = (arr: Number[]) => {
        let list: any[] = []
        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                cardLevelList.map(item => {
                    if (Number(item.id) == arr[i]) {

                        list.push(item)
                    }
                })
            }

        }
        dispatch(changeSelectCardList(list))
        return list;

    }
    const shopPayCountHandle = async () => {
        dispatch(changeShopCount({ type: 1, count: await getShopPayCountHandle(4) }))
    }





    const onLoad = async () => {
        if (finished || isInitLoading.current) return;
        currPage.current++
        await getDataList()
    }

    const getDataList = async () => {
        let ID =  window.localStorage.getItem("userId") || "";
        // if (!ID) {
        //     postWarningInformation({
        //         platform: JSON.stringify({
        //             telegram: window.Telegram.WebApp.platform,
        //             webApp: WebApp.platform,
        //         }),
        //         version: JSON.stringify({
        //             telegram: window.Telegram.WebApp.version,
        //             webApp: WebApp.version,
        //         })
        //         ,
        //         initData: JSON.stringify({
        //             telegram: window.Telegram.WebApp.initData,
        //             webApp: WebApp.initData,
        //         }),
        //         telegram: JSON.stringify(window.Telegram.WebApp.initDataUnsafe),
        //         webApp: JSON.stringify(WebApp.initDataUnsafe),
        //         localStorage: window.localStorage.getItem("userId"),
        //         interfaceName: 'getCards',
        //     })
        //     ID = window.Telegram.WebApp.initDataUnsafe?.user?.id || WebApp.initDataUnsafe?.user?.id || window.localStorage.getItem("userId") || "";
        // }
        try {
            setIsLoading(true)
            const { code, data: { data, count } } = await getCards(ID, currPage.current, pageSize, Number(refiningActive), '', 1)
            if (code === '0') {
                setSaleCardsData((prevData: any) => [...prevData, ...data]);
                total.current = count;
                setIsLoading(false)
                isInitLoading.current = false
                if (data.length == 0) {
                    setFinished(true)
                }
            } else {
                setFinished(true)
                total.current = 0
            }

        } catch (e) {
            setIsLoading(false)
            setFinished(true)
            total.current = 0
        }

        if (currPage.current * pageSize >= total.current) {
            setFinished(true)
            // return false;
        }

    }


    useLayoutEffect(() => {
        getImage()

    }, [refiningCardList])

    const getImage = () => {
        if (refiningCardList.length > 0) {
            indexList.current = indexList.current.map((item: any, i: number) => {
                if (refiningCardList[i]) {

                    let obj = {
                        ...item,
                        image: refiningCardList[i].image
                    }
                    return obj;
                } else {
                    let obj = {
                        ...item,
                        image: ""

                    }
                    return obj;
                }
            })
            dispatch(changeSelectCardList(indexList.current))
        } else {
            indexList.current = indexList.current.map((item: any) => {
                return {
                    ...item,
                    image: ""
                }
            })
            dispatch(changeSelectCardList(indexList.current))
        }
    }



    const refiningHandle = () => {
        if (refiningCardList.length != 2) {
            return false
        }
        setIsShowRefiningConsumption(true)

    }

    useLayoutEffect(() => {
        document.addEventListener('touchstart', touchStartHandle);
        return () => {
            document.removeEventListener('touchstart', touchStartHandle);
            // window.scrollTo(0, 0);
        }
    })


    const touchStartHandle = useCallback(() => {
        window.scrollTo(0, 1);
        ensureDocumentIsScrollable();
    },[])

    const ensureDocumentIsScrollable = () => {
        const isScrollable = document.documentElement.scrollHeight > window.innerHeight;
        if (!isScrollable) {
            document.documentElement.style.setProperty(
                "height",
                "calc(100vh + 0.5px)",
                "important"
            );
        }
    }

    //返回按钮的回调
    const backHandle = () => {
        navigate("/cards")
        dispatch(clearRefiningCardList())
    }
    return (
        <div className='refining-box h-full w-full box-border overflow-hidden'>
            <div className="h-14 flex items-center md:absolute max-md:fixed  w-full z-[9] pt-4 px-4 box-border">
                <Back title={t("shop.refining")} callback={() => { backHandle() }}></Back>
            </div>
            <div className="content-box h-[calc(100%_-_46px)] overflow-auto relative">
                <div className={`tabs mt-16 h-10 w-full flex items-center box-border md:absolute max-md:fixed`} ref={popupRef}>
                    <div className="tabs-list h-full w-full">
                        <Tabs className="w-full h-10 -z-[1px]" beforeChange={() => !isLoading} onClickTab={() => clickTabHandle()} onChange={(name) => { changeTabHandle(name) }} active={refiningActive} sticky align="start" swipeable={true} background="#071919" color="#fff">
                            {tabsList.map((item) => (
                                <Tabs.TabPane key={item.id} name={item.id} title={`${item.name}`}>
                                    {
                                        saleCardsData.length > 0 && <div className={`w-[100%] md:w-[375px] h-[calc(100vh_-_130px)] pb-20 box-border overflow-auto text-white `} >
                                            <List ref={listRef} finished={finished} loading={isLoading} immediateCheck={false} onLoad={onLoad} loadingText={t("other.loading")}>
                                                {
                                                    saleCardsData && saleCardsData.length > 0 ? <Sale saleCardsData={saleCardsData} isPadding={false} type={"refining"}></Sale> : null
                                                }
                                            </List>


                                        </div>
                                    }
                                    {
                                        !isLoading && !saleCardsData.length &&
                                        <div className={'w-[100%] md:w-[375px] h-[calc(100vh_-_120px)] py-4 flex flex-col items-center'}>
                                            <img className="w-[225px] mt-10" src={loading}></img>
                                            <p className='text-[14px] text-[#FFF] mt-[25px] leading-[18px] font-bold'>{t("other.not_found")}</p>

                                        </div>

                                    }
                                    {
                                        isLoading && !saleCardsData.length &&
                                        <div className={'w-[100%] md:w-[375px] py-4 flex flex-col items-center'}>
                                            <Loading type="spinner" size="20" color="#00E49F">
                                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00E49F] to-[#54ADFF]">{t("other.loading")}</span>
                                            </Loading>
                                        </div>

                                    }


                                </Tabs.TabPane>
                            ))}
                        </Tabs>
                    </div>

                </div>
                {
                    isSelect && <TalkMessage text={t("card.select_card")}></TalkMessage>
                }
            </div>


            <Popup visible={popupIsShow} position="bottom" overlay={false} className=" rounded-[16px_16px_0_0]" style={{ background: "rgb(98,98,98,0.85)", zIndex: 888, padding: "18px 16px", overflow: "hidden" }} >
                <div className="container w-full h-full flex items-center justify-center">
                    <div className="flex-1 item-card h-[55px] w-full flex justify-between items-center">

                        {
                            selectCardList.map((item: any, i: number) => {
                                return (
                                    <>
                                        <div key={Math.random()} className="h-[55px] w-[39px] flex flex-col justify-center items-center relative">
                                            <div className="relative h-full w-full overflow-hidden">
                                                <CardItem height={55} width={39} image={item.image} level={Number(item.level)}></CardItem>
                                            </div>


                                            <span className={`text-white text-xs scale-[0.7] absolute ${item.id == "5" ? 'ml-[0px]' : ''}`}>{item.name}</span>
                                        </div>
                                        {
                                            i == 0 && <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                                <defs>
                                                    <linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
                                                        <stop stopColor="#00E49F" offset="0%"></stop>
                                                        <stop stopColor="#54ADFF" offset="100%"></stop>
                                                    </linearGradient>
                                                </defs>
                                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="选择卡牌" transform="translate(-31.000000, -775.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
                                                        <g id="编组" transform="translate(31.000000, 775.000000)">
                                                            <path d="M7,1 C7,0.934666669 6.99333333,0.869666667 6.97999999,0.804999999 C6.968,0.74033333 6.94933333,0.677666665 6.924,0.617000003 C6.89866666,0.557000006 6.86766666,0.499333338 6.831,0.443999998 C6.79499999,0.389999997 6.75366666,0.339666666 6.70699999,0.293000005 C6.66033332,0.246333337 6.60999999,0.205000002 6.556,0.169000001 C6.50133333,0.132333335 6.44366666,0.101333335 6.38299999,0.0760000013 C6.32233333,0.0506666675 6.25966667,0.0320000018 6.195,0.020000004 C6.13033333,0.00666666802 6.06533333,0 6,0 C5.93466666,0 5.86966666,0.00666666802 5.805,0.020000004 C5.74033333,0.0320000018 5.67766666,0.0506666675 5.61699999,0.0760000013 C5.557,0.101333335 5.49933333,0.132333335 5.444,0.169000001 C5.39,0.205000002 5.33966666,0.246333337 5.293,0.293000005 C5.24633333,0.339666674 5.20499999,0.390000005 5.16899999,0.443999998 C5.13233333,0.498666665 5.10133333,0.556333333 5.07599999,0.617000003 C5.05066666,0.677666672 5.03166666,0.740333338 5.019,0.804999999 C5.00633333,0.869666667 5,0.934666669 5,1 L5,5 L1,5 C0.934666657,5 0.86966666,5.00666667 0.804999999,5.02 C0.74033333,5.03199999 0.677666661,5.05066666 0.616999991,5.076 C0.556999995,5.10133334 0.49933333,5.13233334 0.443999998,5.169 C0.389999997,5.20500001 0.339666662,5.24633334 0.292999994,5.293 C0.246333325,5.33966666 0.204999995,5.39 0.169000001,5.444 C0.132333335,5.49866667 0.101333335,5.55633334 0.0760000013,5.61700001 C0.0506666675,5.67766668 0.0316666653,5.74033334 0.0189999945,5.805 C0.00633333149,5.86966667 0,5.93466667 0,6 C0,6.06533332 0.00666666411,6.13033332 0.0199999923,6.195 C0.0319999901,6.25966667 0.0506666597,6.32233333 0.0760000013,6.38299999 C0.101333335,6.44299999 0.132333335,6.50066666 0.169000001,6.556 C0.205000002,6.61 0.246333333,6.66033334 0.292999994,6.707 C0.339666662,6.75366667 0.389999997,6.795 0.443999998,6.831 C0.498666665,6.86766666 0.556333329,6.89866666 0.616999991,6.924 C0.677666661,6.94933333 0.74033333,6.96833333 0.804999999,6.981 C0.869666667,6.99366667 0.934666665,7 1,7 L5,7 L5,11 C5,11.0653333 5.00666666,11.1303333 5.02,11.195 C5.03199999,11.2596667 5.05066666,11.3223333 5.07599999,11.383 C5.10133333,11.443 5.13233333,11.5006667 5.16899999,11.556 C5.20499999,11.6106667 5.24633333,11.661 5.293,11.707 C5.33966666,11.7536667 5.39,11.795 5.444,11.831 C5.49866667,11.8676667 5.55633333,11.8986667 5.61699999,11.924 C5.67766666,11.9493333 5.74033333,11.9683333 5.805,11.981 C5.86966666,11.9936667 5.93466666,12 6,12 C6.06533333,12 6.13033333,11.9933333 6.195,11.98 C6.25966667,11.968 6.32233333,11.9493333 6.38299999,11.924 C6.44299999,11.8986667 6.50066666,11.868 6.556,11.832 C6.61,11.7953333 6.66033333,11.7536667 6.70699999,11.707 C6.75366666,11.6603333 6.79499999,11.61 6.831,11.556 C6.86766666,11.5013333 6.89866666,11.4436667 6.924,11.383 C6.94933333,11.3223333 6.96833333,11.2596667 6.98099999,11.195 C6.99366666,11.1303333 7,11.0653333 7,11 L7,7 L11,7 C11.0653333,7 11.1303333,6.99333333 11.195,6.98 C11.2596667,6.96800001 11.3223333,6.94933334 11.383,6.924 C11.443,6.89866666 11.5006667,6.86766666 11.556,6.831 C11.6106667,6.79499999 11.661,6.75366666 11.707,6.707 C11.7536667,6.66033334 11.795,6.61 11.831,6.556 C11.8676667,6.50133333 11.8986667,6.44366666 11.924,6.38299999 C11.9493333,6.32233332 11.9683333,6.25966666 11.981,6.195 C11.9936667,6.13033333 12,6.06533333 12,6 C12,5.93466666 11.9933333,5.86966666 11.98,5.805 C11.968,5.74033333 11.9493333,5.67766667 11.924,5.61700001 C11.8986667,5.55700001 11.868,5.49933334 11.832,5.444 C11.7953333,5.39 11.7536667,5.33966666 11.707,5.293 C11.6603333,5.24633333 11.61,5.205 11.556,5.169 C11.5013333,5.13233334 11.4436667,5.10133334 11.383,5.076 C11.3223333,5.05066667 11.2596667,5.03166667 11.195,5.019 C11.1303333,5.00633333 11.0653333,5 11,5 L7,5 L7,1 Z" id="路径"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        }
                                        {
                                            i == 1 && <svg width="6px" height="12px" viewBox="0 0 6 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                                <defs>
                                                    <linearGradient x1="37.5%" y1="-1.94289029e-13%" x2="62.5%" y2="100%" id="linearGradient-1">
                                                        <stop stopColor="#00E49F" offset="0%"></stop>
                                                        <stop stopColor="#54ADFF" offset="100%"></stop>
                                                    </linearGradient>
                                                </defs>
                                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="选择卡牌" transform="translate(-47.000000, -775.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
                                                        <g id="编组" transform="translate(47.000000, 775.000000)">
                                                            <path d="M0.982148304,12 C0.725409806,12 0.468671309,11.8992853 0.276017512,11.6989275 C-0.100896453,11.3069171 -0.0903711071,10.6820042 0.299732848,10.3029849 L3.89846848,6.80609728 C4.06221088,6.64698956 4.07753259,6.39252435 3.93390825,6.21453264 L0.219393816,1.60911419 C-0.122346841,1.18576444 -0.057729212,0.564065763 0.363551083,0.220671663 C0.784564914,-0.122990295 1.40316213,-0.0581686318 1.74490279,0.365716831 L5.45928399,4.97100135 C6.24921785,5.95002275 6.16488185,7.34931353 5.26369909,8.22574527 L1.66469699,11.7227669 C1.47404168,11.9078568 1.22796176,12 0.982148304,12 Z" id="路径"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        }
                                        {/* <Icon name="chat-o" /> */}
                                    </>

                                )
                            })
                        }

                    </div>
                    {/* <div className="text text-xs text-white">Two cards of the same level can be refined into a higher-level card.</div> */}

                    <div className="ml-10 w-[174px] h-full flex flex-col">
                        <div className="radio flex items-center mb-2" onClick={() => { dispatch(changeIsSaveCard()) }}>
                            {
                                !isSaveCard ? <div className="select-box w-4 h-4 border rounded-full mt-[2px]"></div> : <img className="w-4 h-4" src={activeImg} alt="" />
                            }

                            <div className="text-xs text-white ml-2">{t("card.retain")} {shopCount[1] > 0 && refiningActive > 2 ? '(' + shopCount[1] + ')' : ''}</div>
                        </div>
                        <ButtonComp title={t("shop.refining")} disabled={refiningCardList.length == 2 ? false : true} callBack={() => { refiningHandle() }}></ButtonComp>
                        {/* <div className={`btn text-sm ${refiningCardList.length == 2 ? 'bg-gradient-to-r' : 'bg-[#a3a3a3]'}  text-white w-[175px] h-[36px] rounded-lg flex justify-center items-center from-[#00E49F] to-[#54ADFF]`} onClick={() => { refiningHandle() }}> Refining </div> */}

                    </div>
                </div>
            </Popup>


            {
                isShowRefiningConsumption && <RefiningConsumption setDialog={(el: string | undefined) => {
                    if (el) {
                        setIsShowRefiningConsumption(false)
                    } else {
                        setIsShowRefiningConsumption(false)
                        setRefiningIsShow(true)
                    }
                }}></RefiningConsumption>
            }



            <Popup visible={refiningIsShow} position="right" overlay={false} style={{ height: "100%" }} >
                <RefinComponent closePopup={() => { setRefiningIsShow(false) }}></RefinComponent>
            </Popup>
        </div>
    )
}


export default Refining;
